<section>
  <app-auth-template
    title="Sign-Up"
    [description]="description()"
  >
    @if (!requestState()) {
      <form
        class="grid gap-x-5"
        (ngSubmit)="register()"
      >
        <section>
          <app-input
            type="text"
            [control]="form.controls.firstname"
            [errorMsg]="'Eingabe erforderlich.'"
            [label]="'Vorname'"
          />

          <app-input
            type="text"
            [control]="form.controls.lastname"
            [errorMsg]="'Eingabe erforderlich.'"
            [label]="'Nachname'"
          />

          <app-dropdown
            [control]="form.controls.gender"
            [errorMsg]="'Eingabe erforderlich.'"
            [options]="options"
            [label]="'Geschlecht'"
          />
        </section>

        <section>
          <app-input
            type="text"
            [control]="form.controls.email"
            [errorMsg]="'Gültige Email Adresse erforderlich.'"
            [label]="'Email'"
          />

          <app-password-input
            errorMsg="Eingabe erforderlich"
            [control]="form.controls.password"
            [label]="'Passwort'"
          />

          <ul class="list-disc pl-8 mb-4">
            <li>Mindestens ein Großbuchstabe</li>
            <li>Mindestens ein Kleinbuchstabe</li>
            <li>Mindestens eine Zahl</li>
            <li>Mindestens 5 Zeichen</li>
          </ul>

          <app-password-input
            [control]="form.controls.confirmPassword"
            [errorMsg]="passwordConformErrorMsg"
            [label]="'Passwort wiederholen'"
          />
        </section>

        <app-checkbox [control]="form.controls.privacyPolicy">
          <span>
            <a
              class="text-blue underline"
              routerLink="/privacy-policy"
            >
              Datenschutzerklärung
            </a>

            akzeptieren
          </span>
        </app-checkbox>

        @if (alert()) {
          <div class="w-full mt-4">
            <app-alert
              [message]="alert()!.message"
              [type]="alert()!.type"
            />
          </div>
        }

        <app-auth-button
          hintText="Du hast bereits ein Benutzerkonto?"
          linkText="Login"
          route="/login"
          type="submit"
          [buttonText]="'Sign-Up'"
          [disabled]="form.invalid || form.disabled || !form.dirty"
          [isLoading]="requestState() === RequestStateEnum.PENDING"
          [showHint]="true"
        />
      </form>
    }
  </app-auth-template>
</section>
